import likebutton from './code/Scripts/components/likebutton/likebutton.vue';

export default {
  components: {
    likebutton,
  },
};
